// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-NfNYRm","side":"side-Fjyb5v","card":"card-wqPVKP","main":"main-AVn2W2"};